import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Dashboard from './Dashboard';
import dashboardApi from './services/dashboardApi';
import './Dashboard.css';
import { fetchSavedSearches } from '../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import SearchType from '../../utility/types/SearchType';

function DashboardPage() {
  const dispatch = useDispatch();
  const [dashboard, setDashboard] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    dispatch(fetchSavedSearches(SearchType.ALERT));
  }, [dispatch]);

  useEffect(() => {
    let cancelled = false;
    const loadUserDashboard = async () => {
      setIsLoading(true);
      setLoadError(null);
      try {
        const dashboardData = await dashboardApi.dashboards.fetch();
        if (!cancelled) setDashboard(dashboardData);
      } catch (err) {
        if (!cancelled) setLoadError('Failed to load dashboard. Please try again.');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    loadUserDashboard().then();
    return () => { cancelled = true; };
  }, []);

  const handleSave = async (savedDashboard) => {
    try {
      const persisted = await dashboardApi.dashboards.save(savedDashboard.id, savedDashboard);
      // Deliberately NOT calling setDashboard here. <Dashboard/> hydrates itself
      // from this returned value. Updating the prop as well gave us two
      // competing hydrations — the prop effect and the save resolution — which
      // are unbatched in React 16 and could land in either order.
      return persisted;
    } catch (err) {
      // The shared RaaAuthenticatedRemoteService attaches structured API
      // errors to `err.data` (matches the pattern used across other slices,
      // e.g. thresholdRangeSlice). Rethrow with `.errors` in the shape
      // <Dashboard/> expects for field-level routing.
      const wrapped = new Error(err.message || 'Failed to save Dashboard.');
      wrapped.errors = Array.isArray(err.data) ? err.data : [];
      throw wrapped;
    }
  };

  if (isLoading) return <div className="dashboard-status">Loading your dashboard...</div>;
  if (loadError) return <div className="dashboard-status dashboard-status--error">{loadError}</div>;

  return (
    <Dashboard
      dashboard={dashboard}
      onSave={handleSave}
      isViewOnly={false}
    />
  );
}

export default DashboardPage;
